import { Injectable } from '@angular/core';
import dexFreight from '@microservices';
import { AuthService } from './auth.service';

@Injectable({
    providedIn: 'root'
})
export class ProntoPagoService {

    constructor(private authService: AuthService) { }

    /**
     * Pide al backend la URL de acceso a Pronto Pago (Integrations.Financing).
     * @param state parámetro opcional del flujo OAuth de /financing/authorize
     * @returns `{ url }` o `null` si no hay sesión activa
     */
    async getAccessUrl(state?: string): Promise<{ url: string } | null> {
        const token = await this.authService.token.get();
        if (!token) return null;

        if (state) return await (dexFreight.Integrations as any).Financing.createFinancingAccess(token, state);

        return await (dexFreight.Integrations as any).Financing.createFinancingAccess(token);
    }

}
